import React from "react"
import CarnivalImage from "../components/CarnivalImage";
import { Link } from "gatsby"

export default class CarnivalCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { children, data, hideMore } = this.props;

    return (
      <div className="game-card" style={{ maxWidth: 350 }}>
        <CarnivalImage />
        <div className="game-footer">
          <Link className="button button-primary" to="/townsville/book-now" style={{marginBottom: 0}}>Book Now</Link>
          {!hideMore && (
            <Link className="button" to="/townsville/carnival/" style={{marginBottom: 0, color: "#FFF"}}>More info</Link>
          )}
        </div>
      </div>
    )
  }
}
